import styled from 'styled-components';

import type { ExtendedTheme } from '@theme/theme';

export const StyledAnchorHeading = styled.div`
  display: flex;
  align-items: center;

  &:hover > button {
    opacity: 1;
  }

  button {
    opacity: 0;
    width: 30px;
    height: 30px;
    margin-left: 8px;
    transition: 0.3s;
    border-radius: ${({ theme }: { theme: ExtendedTheme }) => theme.shape.borderRadius}px;

    &:hover {
      background: ${({ theme }: { theme: ExtendedTheme }) => theme.palette.components.buttonHover};
    }
  }
`;
